import { PrimaryButton } from '@prisjakt/ui/button/variants';
import { ModalSizeEnum } from '@prisjakt/ui/modal';
import { BodyMediumText, H4Text } from '@prisjakt/ui/text/variants';
import React, { useState } from 'react';
import { useAppContext } from 'src/components/app-context';
import Modal from 'src/components/modal-v2';
import { trackProductCollectionUserProductFeedback } from '../../tracking';
import {
  BodyMediumTextCentered,
  QuestionImage,
  QuestionModalBody,
  QuestionModalBodyCenteredContent,
  QuestionText,
  QuestionTextInput,
  UserQuestion,
  UserQuestionBox,
} from './styles';

const UserProductFeedback = () => {
  const { t, market = { cdn: 'https://cdn.pji.nu' } } = useAppContext();
  const [isQuestionModalOpen, setIsQuestionModalOpen] = useState(false);
  const [isQuestionnaireSent, setIsQuestionnaireSent] = useState(false);
  const [questionnaireInputText, setQuestionnaireInputText] = useState('');

  const imageSrcQuestionBox = `${market.cdn}/g/rfe/feedback/question-box.png`;
  const imageSrcThankYouThumb = `${market.cdn}/g/rfe/illustrations/thumb-up-144px.png`;

  const sendQuestionnaire = () => {
    setIsQuestionnaireSent(true);
    trackProductCollectionUserProductFeedback(questionnaireInputText);
  };

  return (
    <>
      <UserQuestion>
        <UserQuestionBox>
          <QuestionImage src={imageSrcQuestionBox} height="56" width="56" />
          <QuestionText>
            <H4Text>{t('feedback', 'uup.product-feedback-title')}</H4Text>
            <PrimaryButton onClick={() => setIsQuestionModalOpen(true)}>
              {t('feedback', 'uup.tip-us')}
            </PrimaryButton>
          </QuestionText>
        </UserQuestionBox>
      </UserQuestion>
      {isQuestionModalOpen ? (
        <Modal
          isOpen
          onRequestClose={() => {
            setIsQuestionModalOpen(false);
            setIsQuestionnaireSent(false);
          }}
          size={ModalSizeEnum.NORMAL}
        >
          {isQuestionnaireSent ? (
            <QuestionModalBodyCenteredContent>
              <QuestionImage
                src={imageSrcThankYouThumb}
                height="72"
                width="72"
              />
              <BodyMediumTextCentered>
                {t('feedback', 'uup.thank-you')}
              </BodyMediumTextCentered>
            </QuestionModalBodyCenteredContent>
          ) : (
            <QuestionModalBody>
              <BodyMediumText>
                {t('feedback', 'uup.product-feedback-explanation')}
              </BodyMediumText>
              <QuestionTextInput
                name="QuestionnaireInput"
                onChange={e => setQuestionnaireInputText(e.target.value)}
              />
              <PrimaryButton
                disabled={questionnaireInputText.length === 0}
                onClick={sendQuestionnaire}
              >
                {t('feedback', 'dialog.send-button')}
              </PrimaryButton>
            </QuestionModalBody>
          )}
        </Modal>
      ) : null}
    </>
  );
};

export default UserProductFeedback;
